import { AlertTriangle } from "lucide-react";

import { formatReviewUploadTime } from "../utils/ehrCsvImportReview";
import classes from "./EhrCsvUploadModal.module.css";

const buildDisplayWarnings = (fileWarnings, counts) => {
	const warnings = [...fileWarnings];
	const total = counts.totalRows || 0;
	const ready = counts.readyToImport || 0;

	if (total > 0 && ready === 0) {
		const details = [];
		if (counts.previouslyImported) {
			details.push(`${counts.previouslyImported} previously imported`);
		}
		if (counts.invalidRows) {
			details.push(`${counts.invalidRows} invalid`);
		}
		if (counts.mappingRequired) {
			details.push(`${counts.mappingRequired} missing required fields`);
		}

		warnings.unshift(
			`No records are ready to import. ${total} detected${
				details.length ? ` (${details.join(", ")})` : ""
			}. Upload a new file or update the CSV to continue.`,
		);
	} else if (ready > 0 && ready < total) {
		warnings.unshift(
			`${ready} of ${total} records will be imported. ${total - ready} record${
				total - ready === 1 ? "" : "s"
			} will be skipped.`,
		);
	}

	return warnings;
};

const EhrCsvReviewStep = ({ importPreview, uploadedByName }) => {
	const fileSummary = importPreview?.fileSummary || {};
	const counts = importPreview?.counts || {};
	const displayWarnings = buildDisplayWarnings(importPreview?.fileWarnings || [], counts);

	return (
		<div className={classes.reviewStepContent}>
			<div className={classes.fileSummaryBox}>
				<div className={classes.fileSummaryTitle}>File Summary</div>
				<dl className={classes.fileSummaryList}>
					<div className={classes.fileSummaryRow}>
						<dt className={classes.fileSummaryLabel}>File Name</dt>
						<dd className={classes.fileSummaryValue} title={fileSummary.fileName || undefined}>
							{fileSummary.fileName || "—"}
						</dd>
					</div>
					<div className={classes.fileSummaryRow}>
						<dt className={classes.fileSummaryLabel}>Records Detected</dt>
						<dd className={classes.fileSummaryValue}>
							{counts.totalRows ? `${counts.totalRows.toLocaleString("en-US")} records` : "—"}
						</dd>
					</div>
					<div className={classes.fileSummaryRow}>
						<dt className={classes.fileSummaryLabel}>Date Range</dt>
						<dd className={classes.fileSummaryValue} title={fileSummary.dateRange || undefined}>
							{fileSummary.dateRange || "—"}
						</dd>
					</div>
					<div className={classes.fileSummaryRow}>
						<dt className={classes.fileSummaryLabel}>Uploaded By</dt>
						<dd
							className={classes.fileSummaryValue}
							title={fileSummary.uploadedByName || uploadedByName || undefined}>
							{fileSummary.uploadedByName || uploadedByName || "—"}
						</dd>
					</div>
					<div className={classes.fileSummaryRow}>
						<dt className={classes.fileSummaryLabel}>Upload Time</dt>
						<dd className={classes.fileSummaryValue}>
							{formatReviewUploadTime(fileSummary.previewedAt)}
						</dd>
					</div>
				</dl>
			</div>

			{displayWarnings.length ? (
				<div className={classes.importWarningsBox}>
					<div className={classes.importWarningsHeader}>
						<AlertTriangle aria-hidden="true" size={18} strokeWidth={2} />
						<span>Import Warnings</span>
					</div>
					<ul className={classes.importWarningsList}>
						{displayWarnings.map((warning) => (
							<li key={warning}>{warning}</li>
						))}
					</ul>
				</div>
			) : null}
		</div>
	);
};

export default EhrCsvReviewStep;
